import log from "./log";

const extractDomainName = (url: string | undefined) => {
	try {
		if (!url) return undefined;
		const domain = url.replace("http://", "").replace("https://", "").split(/[/?#]/)[0];
		return domain;
	} catch (err) {
		log.error({ err }, "Error extracting domain name from URL");
		return undefined;
	}
};
export default extractDomainName;
